import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { Box, Typography, Button, Icon } from '@material-ui/core';

import { usePrevious } from '../../../../utils';
import ActionsCourse from '../../../../store/ducks/course';

import SectionCard from '../../../../components/SectionCard';
import WizardQuestions from './WizardQuestions';
import EmptyImg from './EmptyImg';
import CompletedImg from './CompletedImg';
import Loading from './Loading';
import useStyles from './styles';

const Questions = props => {
  const { onSectionChange } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { current, list } = useSelector(state => state.course);
  const [questionsRequested, setQuestionsRequested] = useState(false);
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState({});
  const [questionsCompleted, setQuestionsCompleted] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const prevCurrent = usePrevious(current);

  const checkLessonChange = useCallback(
    (course, lesson) =>
      prevCurrent &&
      (course !== prevCurrent.course || lesson !== prevCurrent.lesson),
    [prevCurrent],
  );

  useEffect(() => {
    if (current) {
      const { course, lesson } = current;
      if (prevCurrent && checkLessonChange(course, lesson)) {
        setQuestionsRequested(false);
      }
    }
  }, [checkLessonChange, current, prevCurrent]);

  useEffect(() => {
    if (
      current &&
      current.course in list &&
      list[current.course].lessons &&
      current.lesson in list[current.course].lessons
    ) {
      const { course, lesson } = current;
      const lessonInfos = list[course].lessons[lesson];
      const lessonChange = checkLessonChange(course, lesson);

      if (!lessonInfos.questionsLoaded || lessonChange) {
        if (!questionsRequested) {
          dispatch(ActionsCourse.requestLessonQuestions(course, lesson));
          setQuestionsRequested(true);
        }
        setLoading(true);
      }
      if (lessonInfos.questionsLoaded) {
        setQuestions(lessonInfos.questions);
        setQuestionsCompleted(lessonInfos.questionsCompleted);
        setLoading(false);
      }
    }
  }, [checkLessonChange, current, dispatch, list, questionsRequested]);

  useEffect(() => {
    const toRender = !loading && !!Object.keys(questions).length;
    onSectionChange('render', toRender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, questions]);

  const handleOpenModal = useCallback(() => {
    setOpenModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  return loading ? (
    <SectionCard className="container-section">
      <Loading />
    </SectionCard>
  ) : (
    <>
      {!!Object.keys(questions).length && (
        <SectionCard
          className="container-section"
          id="questions"
          title="Questionário"
        >
          <ReactResizeDetector
            handleHeight
            onResize={(width, height) => onSectionChange('height', height)}
          />
          <Box className={classes.container}>
            {questionsCompleted ? <CompletedImg /> : <EmptyImg />}
            <Typography className="msg-text" variant="subtitle1">
              {questionsCompleted
                ? 'Você já respondeu o questionário desta aula.'
                : 'Você ainda não respondeu o questionário desta aula.'}
            </Typography>
            <Button
              className={`msg-btn ${questionsCompleted ? 'completed' : ''}`}
              onClick={handleOpenModal}
              startIcon={<Icon>description</Icon>}
            >
              {questionsCompleted
                ? 'Visualizar respostas'
                : 'Responder questionário'}
            </Button>
          </Box>
          {openModal && (
            <WizardQuestions
              open={openModal}
              handleClose={handleCloseModal}
              questions={questions}
            />
          )}
        </SectionCard>
      )}
    </>
  );
};

export default Questions;
